<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import { useAppStore } from '@/stores/app'
import Loading from '@/components/common/Loading.vue'
import GTagManager from './components/GTagManager.vue'
import GTagCodes from './shared/constants/GTagCodes'
import SpriteLoader from './components/logos/SpriteLoader.vue'

const appStore = useAppStore()
const claroGoogleTagId = computed(() => GTagCodes.claro[appStore.country].code)
</script>

<template>
  <SpriteLoader />
  <RouterView />
  <Loading v-if="appStore.isLoading" />
  <GTagManager :google-tag-id="claroGoogleTagId" />
</template>
